module.exports = __webpack_public_path__ + "img/674.d4d0f1d2.jpg";